import { EntityStore } from './entity-store'

type PaymentTypesStore = EntityStore<'paymentTypes'>

/**
 * Stores information on the retailer's payment types.
 */
export const paymentTypesStore: PaymentTypesStore = new EntityStore({
  entityStoreName: 'paymentTypes',
  entityName: 'payment_types',
  syncDeleted: true,
})
